import { Col, Row } from 'antd'
import classNames from 'classnames'
import { useState } from 'react'
import { MyIcon } from '~/components/ui/MyIcon'
import { getAIMenu_pictureGraph_aiCreateArtworkOptionMenu_patternModelOptions } from '~/graphqls/types'

interface Props {
  value?: number
  onChange?: (a: number | undefined) => void
  options: getAIMenu_pictureGraph_aiCreateArtworkOptionMenu_patternModelOptions[]
  numPutOnDesk?: number
}

export default function ModelCodeSelect({
  value,
  onChange,
  options,
  numPutOnDesk = 8,
}: Props) {
  const [expand, setExpand] = useState(false)
  const showMore = options.length > numPutOnDesk
  const _options = options.slice(0, expand ? Infinity : numPutOnDesk)

  return (
    <>
      <Row gutter={12}>
        {_options.map(item => {
          const isActive = item.modelCode === value
          return (
            <Col span={6} key={item.modelCode} className="mb-3">
              <div
                onClick={() => {
                  onChange?.(item.modelCode!)
                }}
              >
                <Item isActive={isActive} name={item.name!} />
              </div>
            </Col>
          )
        })}
      </Row>
      {showMore && (
        <div
          className="w-10 h-7 bg-neutral-200 flex items-center justify-center rounded-full mx-auto cursor-pointer"
          onClick={() => {
            setExpand(!expand)
          }}
        >
          <MyIcon
            icon="arrow-down-simple"
            className={classNames('text-neutral-900 text-[24px]', {
              'rotate-180': expand,
            })}
          />
        </div>
      )}
    </>
  )
}

const Item = ({ isActive, name }: { isActive: boolean; name: string }) => {
  return (
    <div
      className={classNames(
        'rounded-full text-neutral-800 font-semibold p-1 text-sm border-2 text-center cursor-pointer text-overflow',
        [[isActive ? 'border-neutral-500' : 'border-transparent']]
      )}
      style={{
        background: isActive
          ? 'radial-gradient(74.76% 334.54% at 49.84% 50%, #374176 0%, rgba(55, 65, 118, 0) 100%)'
          : '#23262F',
      }}
    >
      {name}
    </div>
  )
}
